import React, { useState } from 'react';

const input = 'w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded-lg text-white text-sm placeholder-slate-500';
const btn = 'w-full py-2 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-40 text-white rounded-lg text-sm font-semibold transition-colors';

const FORMS = {
  cash: { title: 'Record cash reserve', path: 'reserve/cash', fields: [['amount_usd', 'Amount (USD)', 'number'], ['reference', 'Bank statement / wire reference']] },
  withdraw: { title: 'Withdraw surplus cash', path: 'reserve/withdraw', fields: [['amount_usd', 'Amount (USD)', 'number'], ['reference', 'Bank reference']] },
  asset: { title: 'Record Treasury asset', path: 'assets', fields: [['security_reference', 'CUSIP or custody record'], ['custodian', 'Custodian wallet address'],
    ['face_usd', 'Face value (USD)', 'number'], ['market_usd', 'Market value (USD)', 'number'], ['maturity_date', 'Maturity', 'date']] },
  mint: { title: 'Mint BETH', path: 'mint', fields: [['to', 'Recipient email or wallet'], ['amount_usd', 'Amount (BETH = USD)', 'number']] },
  redeem: { title: 'Start a redemption', path: 'redemptions/request', fields: [['holder', 'Holder email or wallet'], ['amount_usd', 'Amount (BETH)', 'number']] },
};

const Form = ({ id, cfg, busy, post }) => {
  const [v, setV] = useState({});
  const submit = (e) => {
    e.preventDefault();
    const body = Object.fromEntries(cfg.fields.filter(([k]) => v[k] !== undefined && v[k] !== '')
      .map(([k, , t]) => [k, t === 'number' ? parseFloat(v[k]) : v[k]]));
    post(cfg.path, body, () => setV({}));
  };
  return (
    <form onSubmit={submit} className="bg-slate-900/50 rounded-lg p-4 border border-slate-700 space-y-2" data-testid={`stablecoin-form-${id}`}>
      <p className="text-white text-sm font-medium">{cfg.title}</p>
      {cfg.fields.map(([k, label, type]) => (
        <input key={k} type={type || 'text'} step={type === 'number' ? '0.01' : undefined} min={type === 'number' ? '0.01' : undefined}
          placeholder={label} value={v[k] || ''} onChange={(e) => setV({ ...v, [k]: e.target.value })}
          required={k !== 'maturity_date'} className={input} data-testid={`stablecoin-${id}-${k}`} />
      ))}
      <button type="submit" disabled={busy} className={btn} data-testid={`stablecoin-${id}-submit`}>{busy ? 'Confirming on-chain...' : cfg.title}</button>
    </form>
  );
};

export const StablecoinForms = ({ busy, post }) => (
  <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
    {Object.entries(FORMS).map(([id, cfg]) => <Form key={id} id={id} cfg={cfg} busy={busy} post={post} />)}
  </div>
);
